import { render, staticRenderFns } from "./tabar.vue?vue&type=template&id=33697bfc&scoped=true&"
import script from "./tabar.vue?vue&type=script&lang=js&"
export * from "./tabar.vue?vue&type=script&lang=js&"
import style0 from "./tabar.vue?vue&type=style&index=0&id=33697bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33697bfc",
  null
  
)

export default component.exports